export type ChatbooksEnvironment = 'production' | 'staging';

export const FUNCTIONS_BASE_URL = (
  process.env.REACT_APP_FUNCTIONS_BASE_URL ||
  'https://us-central1-chatbooks-concierge-5fdff.cloudfunctions.net'
).replace(/\/+$/, '');

export const CHATBOOKS_ENV: ChatbooksEnvironment =
  process.env.REACT_APP_CHATBOOKS_ENV === 'staging' ? 'staging' : 'production';

export const IS_LOCAL_FUNCTIONS =
  FUNCTIONS_BASE_URL.includes('127.0.0.1') ||
  FUNCTIONS_BASE_URL.includes('localhost');

/**
 * Shared Chatbooks Studio Google OAuth client (Chatbooks GCP project).
 * Same client as studio_admin — override via REACT_APP_GOOGLE_SSO_CLIENT_ID.
 */
const DEFAULT_STUDIO_GOOGLE_SSO_CLIENT_ID =
  '215152887776-iivuplmomhp54f48mmrte2ho3qp8ini6.apps.googleusercontent.com';

export const GOOGLE_SSO_CLIENT_ID =
  process.env.REACT_APP_GOOGLE_SSO_CLIENT_ID?.trim() ||
  DEFAULT_STUDIO_GOOGLE_SSO_CLIENT_ID;

export const IS_GOOGLE_SSO_CONFIGURED = GOOGLE_SSO_CLIENT_ID.trim().length > 0;
